export default from './LabelWithBadge';



// WEBPACK FOOTER //
// ./src/components/LoanOfficerRealEstateAgents/components/Tabs/components/LabelWithBadge/index.js